import React, { Component } from 'react';
import { connect } from 'react-redux';
import ErrorScreen from './components/ErrorScreen/ErrorScreen';
import LandingPage from './components/LandingPage/LandingPage';
import IdentityConfirmation from './components/IdentityConfirmation/IdentityConfirmation';
import Player from './components/Player/AsyncPlayer';
import UnsupportedBrowser from './components/UnsupportedBrowser/UnsupportedBrowser';
import asyncScriptLoader from './services/asyncScriptLoader';
import * as actions from './constants/actions';
import versionFile from './Version.txt';
import Cookies from 'universal-cookie';
import { isNullOrUndefined } from 'util';
import URLS from './constants/urls';
import SCOPES, {IMLPSCOPES} from './constants/scopes';
import './App.css';
import { LOGIN_TYPE_MANUAL, LOGIN_TYPE_OTT } from './constants/loginTypes';
import {isValidProduct} from './constants/products';
import { parseQueryString, buildQueryString } from './services/queryStringParameters';
import { getEnvironmentFromUrl } from './services/network';
import Auth from './services/auth.service';
import { initializeUserManager, signinRedirect, signinRedirectCallback, getUser, removeUser } from './services/oidc';
import store from 'store';

//const Nonce = require('nonce-fast');


const mapStateToProps = state => ({
	authenticated: state.app.authenticated,
	error: state.app.error,
	scriptsLoaded: state.app.scriptsLoaded,
	identityConfirmed: state.app.identityConfirmed,
	params: state.app.params,
	ctrl: state.app.ctrl,
	meta: state.app.meta,
	shift: state.app.shift,
	supportedBrowser: state.app.supportedBrowser,
	selectedProduct: state.app.selectedProduct,
	userProducts: state.app.userProducts,
	version: state.app.version,
	imlp: state.app.imlp
});

const mapDispatchToProps = dispatch => ({
	onInit: () => dispatch({ type: actions.APP_INIT}),
	onAuthenticated: (accessToken, idToken, loginType) => dispatch({ type: actions.APP_AUTHENTICATED, payload: {accessToken: accessToken, idToken: idToken, loginType: loginType} }),
	onScriptsLoaded: () => dispatch({ type: actions.APP_SCRIPTS_LOADED }),
	onKeyDown: key => dispatch({ type: actions.APP_KEYDOWN, payload: key }),
	onKeyUp: key => dispatch({ type: actions.APP_KEYUP, payload: key }),
	onWarp: () => dispatch({ type: actions.APP_WARP }),
	onVersionReceived: (version) => dispatch({ type: actions.APP_VERSION_RECEIVED, payload: version }),
	onProductSelected: (product) => dispatch({type: actions.APP_SELECTED_PRODUCT, payload: product}),
	onProductCleared: () => dispatch({type: actions.APP_CLEARED_PRODUCT }),
	onStashQueryParams: () => dispatch({type: actions.APP_STASH_QUERY_PARAMS, payload: window.location.search}),
	onFetchQueryParams: () => dispatch({type: actions.APP_APPLY_STORED_QUERY_PARAMS}),
	onIMLPSet: (imlp) => dispatch({type: actions.APP_AUTHTYPE_SET, payload: imlp})
});

class App extends Component {

	constructor(props) {
		super(props);
		props.onInit();

		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);
		this.handleImplicitSsoToken = this.handleImplicitSsoToken.bind(this);
		this.handleOneTimeToken = this.handleOneTimeToken.bind(this);
		this.checkForCacheClear = this.checkForCacheClear.bind(this);
		this.startImplicitSSO = this.startImplicitSSO.bind(this);
		this.setVersion = this.setVersion.bind(this);
		this.getHashParameters = this.getHashParameters.bind(this);
		this.shouldAttemptToAuthenticateSession = this.shouldAttemptToAuthenticateSession.bind(this);
		this.determineAuthenticationMethod = this.determineAuthenticationMethod.bind(this);
		this.getProduct = this.getProduct.bind(this);
		this._startImplicitSSOForProductLaunch = this._startImplicitSSOForProductLaunch.bind(this);
		this._startImplicitSSOForProductSelection = this._startImplicitSSOForProductSelection.bind(this);
		this._startPKCEForProductLaunch = this._startPKCELogin.bind(this);
		this._getUserFromAuthCode = this._getUserFromAuthCode.bind(this);
		this._removeCurrentUser = this._removeCurrentUser.bind(this);
	}

	getHashParameters() {
		if(window.location.hash == null){
			return null;
		}

		var hash = window.location.hash.substr(1);

		var result = hash.split('&').reduce(function (result, item) {
			var parts = item.split('=');
			result[parts[0]] = parts[1];
			return result;
		}, {});

		return result;
	}

	componentDidMount() {
		const loader = asyncScriptLoader(window.document, window.Promise, 30000);
		const promises = [
			`${ process.env.PUBLIC_URL }/Build/{{{ LOADER_FILENAME }}}`
		].map((script) => loader(script));

		
		window.Promise.all(promises)
			.then(this.props.onScriptsLoaded)
			.catch(err => console.error(err));

		window.addEventListener('keydown', this.handleKeyDown);
		window.addEventListener('keyup', this.handleKeyUp);

		this.getVersion(this.setVersion);

		var params = parseQueryString(window.location.search);
		this.getProduct(params);
		this.determineAuthenticationMethod(params);
	}

	componentDidUpdate(prevProps) {
		if(prevProps.imlp === undefined) return;
		if(prevProps.imlp !== this.props.imlp) {
			const params = parseQueryString(window.location.search);
			this.determineAuthenticationMethod(params);
		}
	}

	componentWillUnmount() {
		console.log('Unmounting');
		window.removeEventListener('keydown', this.handleKeyDown);
		window.removeEventListener('keyup', this.handleKeyUp);
	}

	handleKeyDown(e) {
		const key = e.key || String.fromCharCode(e.keyCode);
		this.props.onKeyDown(key);

		if (key === 'G' && (e.ctrlKey || e.metaKey) && e.shiftKey) {
			window.open('?networkhealth');
		}

		if (key === 'E' && (e.ctrlKey || e.metaKey) && e.shiftKey) {
			this.props.onWarp && this.props.onWarp();
		}
	}

	handleKeyUp(e) {
		const key = e.key || String.fromCharCode(e.keyCode);
		this.props.onKeyUp(key);
	}

	handleImplicitSsoToken(access_token, id_token) {
		this.props.onFetchQueryParams();
		this.props.onAuthenticated(access_token, id_token, LOGIN_TYPE_MANUAL);
	}

	handleOneTimeToken(params, token) {
		let environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);

		// Make sure we set the product that they have selected.
		let product = params["selectedProduct"];
		this.props.onProductSelected(product);

		// The url to redirect back to.
		let redirect_uri = encodeURIComponent(URLS[environment].product + window.location.search);

		delete params["ott"];
		let constructedQueryString = buildQueryString(params);
		window.history.replaceState(null, null, constructedQueryString);

		Auth.redeemOneTimeToken(token, redirect_uri, environment)
			.then(response => {
				// We need to figure out how to get the identity token from this.
				this.props.onAuthenticated(response["access_token"], null, LOGIN_TYPE_OTT);
			})
			.catch(err => {
				params["ott"] = token;
				constructedQueryString = buildQueryString(params);
				window.history.replaceState(null, null, constructedQueryString);

				console.error(err);
			});
	}

	determineIfNeedToWaitForILAuth(urlParams) {
		const useILAuth = urlParams.hasOwnProperty("authSource") && urlParams["authSource"] === "ILAuth";
		this.props.onIMLPSet(!useILAuth);

		return !useILAuth !== this.props.imlp;
	}

	decodeStateParam(urlParams) {
		if(!urlParams.hasOwnProperty("state") || isNullOrUndefined(urlParams['state'])) return;

		const state = JSON.parse(urlParams['state']);

		return state;
	}

	determineAuthenticationMethod(urlParams) {
		if (!this.shouldAttemptToAuthenticateSession(urlParams)) {
			return;
		}

		if(this.determineIfNeedToWaitForILAuth(urlParams)) {
			return;
		}

		// See what type of login we're tyring to do.
		const hashParams = this.getHashParameters();

		let implicitSSOAccessToken = null;
		let implicitSSOIdentityToken = null;
		let oneTimeUseToken = null;

		if(urlParams != null) {
			implicitSSOAccessToken = urlParams["access_token"];
			implicitSSOIdentityToken = urlParams["id_token"];
			oneTimeUseToken = urlParams["ott"];
		}

		if(hashParams != null) {
			if(implicitSSOAccessToken == null) {
				implicitSSOAccessToken = hashParams["access_token"];
			}

			if(implicitSSOIdentityToken == null){
				implicitSSOIdentityToken = hashParams["id_token"];
			}
		}

		if(implicitSSOAccessToken != null) {
			this.handleImplicitSsoToken(implicitSSOAccessToken, implicitSSOIdentityToken);
		} else if(oneTimeUseToken != null) {
			this.handleOneTimeToken(urlParams, oneTimeUseToken);
		} else {
			if (this.props.imlp)
				this.startPKCELogin(urlParams);
			else
				this.startImplicitSSO(urlParams);
		}
	}

	startImplicitSSO(params) {
		console.log("start implicit sso");
		// If they've indicated a product to launch, redirect to it.
		if(params.hasOwnProperty("selectedProduct") && isValidProduct(params["selectedProduct"])){
			this._startImplicitSSOForProductLaunch(params);
		} else { // Otherwise, assume they need to pick a product.
			this._startImplicitSSOForProductSelection(params);
		}
	}

	_startImplicitSSOForProductLaunch(params) {
		const environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);
		const { imlp } = this.props;
		// Make sure we set the product that they have selected.
		const product = params["selectedProduct"];
		this.props.onProductSelected(product);
		// Initiate our OAuth process.
		const baseAuth = imlp ? URLS[environment].authEdge : URLS[environment].auth;
		const auth = baseAuth + "/connect/authorize";
		//Decode state
		const decodedState = this.decodeStateParam(params);
		const useCurrentState = !isNullOrUndefined(decodedState) && decodedState.authSource === 'IMLP';
		const currentQuerys = encodeURIComponent(decodedState);
		// Create our state and convert it to base 64.
		const state = "&state=" + Buffer.from(JSON.stringify({
			client_params: window.location.search
		})).toString("base64");
		// The url to redirect back to.
		const encodedUri = imlp ? encodeURIComponent(URLS[environment].product) : encodeURIComponent(URLS[environment].product + window.location.search);
		const redirect_uri = "&redirect_uri=" + encodedUri;
		const nonce = "&nonce=123456789";																					 // A number to indicate that this wasn't a request replayed. We fake it for now.
		const scopes = imlp ? IMLPSCOPES : SCOPES;
		const scope = "&scope=" + encodeURIComponent(scopes);											 // We need the scopes for the various backend services we may use.
		const response_type = "&response_type=" + encodeURIComponent("id_token token"); // We need the access_token and the id_token.
		const replaceURI = useCurrentState ? auth + "?client_id=WebGLClient" + currentQuerys : auth + "?client_id=WebGLClient" + scope + redirect_uri + response_type + state + nonce;
		window.location.replace(replaceURI);
	}

	_startImplicitSSOForProductSelection(params){
		this.props.onStashQueryParams();
		// Pass the sitecode onto the universal-login-page
		let sitecode = "";
		if(params.hasOwnProperty("sitecode")) {
			sitecode = "?sitecode=" + params["sitecode"];
		}
		let environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);
		window.location.replace(URLS[environment].signin + sitecode);
	}

	startPKCELogin(params){

		initializeUserManager();
		getUser().then((user) => {

		if(user != null){	//if a user currently exists, remove it so we're clean before attempting to obtain a user
			this._removeCurrentUser();
		}
		if(params.hasOwnProperty("code")){ //else if we have an auth code to redeem, redeem an auth code for an access token
			this._getUserFromAuthCode(params);
		}else { // Otherwise, we need to begin login flow
			this._startPKCELogin(params);
		}
	});
	}

	getProduct(params)
	{
		let product = store.get('product');
		product = (isValidProduct(product)) ? product : null;
		if (params.hasOwnProperty("selectedProduct") && isValidProduct(params["selectedProduct"]))
		{
			product = params["selectedProduct"];
		}
		if (product != null)
			this.props.onProductSelected(product);
		else
			this.props.onProductCleared();
	}

	_startPKCELogin(params){
		signinRedirect().catch((error) => console.error(error));
	}

	_getUserFromAuthCode(params){
		const environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);                                                                                                                                                                                                                                                                            ;
		signinRedirectCallback().then((user) => 
		{
			this.props.onAuthenticated(user.access_token, user.id_token, LOGIN_TYPE_MANUAL);
			let product = this.props.selectedProduct;
			if (!isValidProduct(product))
				window.location.replace(URLS[environment].productSelection);
		});
	}

	_removeCurrentUser()
	{
		removeUser();
	}

	shouldAttemptToAuthenticateSession(params){
		return !(params.hasOwnProperty('dev') || !!params.activity);
	}

	clearCache() {
		console.log("clearing cache");
		var idb = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
		if (!idb) return;

		var databaseName = "/idbfs";
		var req = indexedDB.deleteDatabase(databaseName);

		req.onsuccess = function () {
			console.log("Deleted idbfs database successfully");
		};
		req.onerror = function () {
			console.log("Couldn't delete idbfs database");
		};
		req.onblocked = function () {
			console.log("Couldn't delete idbfs database due to the operation being blocked");
		};

		var databaseName2 = "CachedXMLHttpRequest";
		var req2 = indexedDB.deleteDatabase(databaseName2);

		req2.onsuccess = function () {
			console.log("Deleted CachedXMLHttpRequest database successfully");
		};
		req2.onerror = function () {
			console.log("Couldn't delete CachedXMLHttpRequest database");
		};
		req2.onblocked = function () {
			console.log("Couldn't delete CachedXMLHttpRequest database due to the operation being blocked");
		};
	}

	checkForCacheClear() {
		var cookies = new Cookies();
		var versionCookie = cookies.get('version');
		var version = this.state.version.trim();
		// console.log("Current version cookie: " + versionCookie);

		if (!isNullOrUndefined(versionCookie) && versionCookie !== "" && !isNullOrUndefined(version) && version !== "") {
			// console.log("Cookie version: -" + versionCookie + "-, Current app version: -" + version + "-");
			if (versionCookie.toString().valueOf() !== version.toString().valueOf()) {
				// console.log("Clearing cache.");
				this.clearCache();
				cookies.set('version', version, { path: '/' });
				window.location.reload();
			}
		}
		else {
			if (!isNullOrUndefined(version) && version !== "") {
				cookies.set('version', version, { path: '/' });
				// console.log("No version cookie found. Setting cookie for version " + version + ".");
			}
		}
	}

	getVersion(callback) {
		var client = new XMLHttpRequest();
		client.onreadystatechange = function () {
			callback(client.responseText);
		}
		client.open('GET', versionFile + '?v=' + Math.random());
		client.send();
	}

	setVersion(versionText) {
		this.props.onVersionReceived(versionText);
	}

	render() {
		const params = this.props.params || {};
		const supportedBrowser = this.props.supportedBrowser;
		const error = this.props.error || params.error;
		const authenticated = this.props.authenticated || !this.shouldAttemptToAuthenticateSession(params);
		const identityConfirmed = this.props.identityConfirmed || !this.shouldAttemptToAuthenticateSession(params);
		const selectedProduct = this.props.selectedProduct || !this.shouldAttemptToAuthenticateSession(params);
		const scriptsLoaded = this.props.scriptsLoaded;

		if (error) {
			return <ErrorScreen error={ error } />;
		} else if (!supportedBrowser) {
			console.log("unsupported");
			return <UnsupportedBrowser />;
		}
		else if (authenticated && selectedProduct && !identityConfirmed) 
		{
			return (
				<div>
					<LandingPage status="Confirming Identity" version={this.props.version} faded={true}/>
					<IdentityConfirmation imlp={this.props.imlp}/>
				</div>
			);
		}
		else if (authenticated && selectedProduct && identityConfirmed && !scriptsLoaded)
		{
			return <div><LandingPage status="Loading Scripts" version={this.props.version} faded={false}/></div>
		}
		else if (authenticated && selectedProduct && identityConfirmed && scriptsLoaded) {
			return <Player id="player" webGlJson={ `${ process.env.PUBLIC_URL }/Build/WebGL.json` } version={this.props.version} />;
		} else {
			return <LandingPage status="Verifying Identity" version={this.props.version}/>
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js